"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Section = void 0;
const information_1 = require("./information");
class Section {
    constructor(sort, equivalents, informations, relations) {
        this.sort = sort;
        this.equivalents = equivalents;
        this.informations = informations;
        this.relations = relations;
    }
    getEquivalents(onlyVisible) {
        let equivalents = this.equivalents;
        if (onlyVisible) {
            equivalents = equivalents.filter((equivalent) => !equivalent.hidden);
        }
        return equivalents;
    }
    getInformations(onlyVisible) {
        let informations = this.informations;
        if (onlyVisible) {
            informations = informations.filter((information) => !information.hidden);
        }
        return informations;
    }
    getNormalInformations(onlyVisible) {
        let informations = this.informations.filter((information) => information instanceof information_1.NormalInformation);
        if (onlyVisible) {
            informations = informations.filter((information) => !information.hidden);
        }
        return informations;
    }
    getPhraseInformations(onlyVisible) {
        let informations = this.informations.filter((information) => information instanceof information_1.PhraseInformation);
        if (onlyVisible) {
            informations = informations.filter((information) => !information.hidden);
        }
        return informations;
    }
    getExampleInformations(onlyVisible) {
        let informations = this.informations.filter((information) => information instanceof information_1.ExampleInformation);
        if (onlyVisible) {
            informations = informations.filter((information) => !information.hidden);
        }
        return informations;
    }
    getFields(onlyVisible) {
        const equivalents = this.getEquivalents(onlyVisible);
        const informations = this.getInformations(onlyVisible);
        const relations = this.relations;
        const fields = [...equivalents, ...informations, ...relations];
        return fields;
    }
}
exports.Section = Section;
